import { ConfigProvider } from "antd";
import viVN from "antd/locale/vi_VN";
import type { ReactNode } from "react";

/**
 * Nền design-system AntD theo UIUX baseline v2.0 (Spec S4.2 D2).
 * Giá trị hard-code tại đây là mapping 1-1 với token trong `styles/tokens.css`;
 * S4.3/S4.4 chỉ consume provider này, không tự định nghĩa token.
 */
export function NccAntdProvider({ children }: { readonly children: ReactNode }) {
  return (
    <ConfigProvider
      locale={viVN}
      theme={{
        token: {
          colorPrimary: "#1d4ed8",
          colorSuccess: "#059669",
          colorWarning: "#d97706",
          colorError: "#dc2626",
          colorInfo: "#1d4ed8",
          colorText: "#0f172a",
          colorTextSecondary: "#64748b",
          colorBorder: "#e2e8f0",
          colorBgLayout: "#f8fafc",
          colorBgContainer: "#ffffff",
          borderRadius: 8,
          // Touch target desktop: control min-height 36px (mobile 44px qua media query ở screen).
          controlHeight: 36,
          fontFamily: '"Be Vietnam Pro", Inter, "Segoe UI", Arial, sans-serif',
          fontSize: 14,
        },
        components: {
          Button: {
            controlHeight: 36,
          },
          Table: {
            headerBg: "#f1f5f9",
            headerColor: "#64748b",
          },
          Tabs: {
            horizontalItemPadding: "10px 16px",
          },
          Input: {
            controlHeight: 36,
          },
          Tag: {
            defaultBg: "#f1f5f9",
            defaultColor: "#0f172a",
          },
          Empty: {
            colorTextDescription: "#64748b",
          },
          Result: {
            titleFontSize: 24,
            subtitleFontSize: 14,
          },
          Skeleton: {
            paragraphLiHeight: 22,
          },
          Menu: {
            darkItemBg: "transparent",
            darkSubMenuItemBg: "transparent",
            darkPopupBg: "#0f2747",
            darkItemColor: "#dbeafe",
            darkItemSelectedBg: "#1d4ed8",
            darkItemSelectedColor: "#ffffff",
            // Menu theme="dark" trong AppShell đọc group title color từ darkGroupTitleColor
            // (AntD 6.6.1 map groupTitleColor := darkGroupTitleColor cho dark token set).
            darkGroupTitleColor: "#93c5fd",
            groupTitleFontSize: 11,
            itemHeight: 40,
            itemMarginInline: 4,
            itemBorderRadius: 6,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
